export default "__VITE_ASSET__BXvyOsQ6__"